import React, { useEffect, useRef, useState } from 'react';
import { Container, Content } from 'rsuite';

import { AlchemicLoader } from '../../components/index.js';

import './privacy.scss';

// TODO link in giro

const PrivacyPage = () => {
  const Privacy = useRef(0);
  let [loading, setLoading] = useState(true);

  useEffect(
    ()  => {
      const run = async () => {
        const { PrivacyContent } = await import('./privacy.js');
        Privacy.current = PrivacyContent
        setLoading(false);
      }
      run();
    },
    []
  );

  const PrivacyContent = Privacy.current;

  return (
    <div>
      <Container className="lf-page-privacy">
        <Content className="privacy-content">
          {loading && (
            <div style={{ paddingTop: '130px' }}>
              <AlchemicLoader />
            </div>
          )}
          {!loading && <PrivacyContent />}
        </Content>
      </Container>
    </div>
  );
};

export { PrivacyPage };
